import DonutChart, { DonutChartData } from "@/components/visualizations/DonutChart/DonutChart";
import useTranslation from "@/hooks/useTranslation";
import { useCompanyImpactTotals } from "@/pages/dashboard/hooks/useCompanyImpact";
import { ImpactMetric } from "@/pages/dashboard/utils/types";
import Widget from "../../components/Widget/Widget";

export default function CorporateImpactPerSegment({ metric }: { metric: ImpactMetric }) {
  const { data, isLoading, isFetching } = useCompanyImpactTotals({ metrics: [metric.key] });
  const translation = useTranslation();

  const chartData: DonutChartData =
    data?.chapters && data.chapters.length > 0
      ? data.chapters.map((row) => ({
          label: row.label,
          value: row[metric.key],
        }))
      : [];

  return (
    <Widget
      title={"Company impact per life cycle phase"}
      tooltip={translation["dashboard"]["company"]["per_segment"]}
    >
      <DonutChart
        colorPalette="ordinal_blue"
        data={chartData}
        format={metric.formatter}
        loading={isLoading || isFetching}
      />
    </Widget>
  );
}
